import * as v from "valibot";

const newsScheme = v.object({
    /** お知らせの日付 */
    date: v.string(),

    /** お知らせの内容 */
    text: v.string(),
});

export type News = v.InferOutput<typeof newsScheme>;

/**
 * 与えられたデータをお知らせデータとしてパースする。
 *
 * @param data 対象のデータ
 * @returns パース結果
 */
export const parseNews = (data: unknown) => {
    return v.parse(newsScheme, data);
};

/**
 * 与えられたデータをお知らせデータの配列としてパースする。
 *
 * @param data 対象のデータ
 * @returns パース結果
 */
export const parseNewsArray = (data: unknown) => {
    if (Array.isArray(data)) {
        return data.map((x) => parseNews(x));
    } else {
        throw new TypeError("data is not an array.");
    }
};
